import { Address } from '@univacity/shared/types';
import { kebabCase } from 'lodash';

export class StringUtil {
  static passwordRex =
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/;
  static emailRex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,18}$/;

  static youtubeRegx =
    /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube(-nocookie)?\.com|youtu.be))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/;

  static viemoRegx =
    /(http|https)?:\/\/(www\.|player\.)?vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|video\/|)(\d+)(?:|\/\?)/;

  static phoneRegx =
    /^null|$|((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/;

  static externalUrlRegx =
    /((http|https):\/\/(?!www.univacity.com)[\w./\-=?#]+)/;

  static passwordRexMessage =
    'Password must contain at least 1 Uppercase, Lowercase, Number, and Special Character';
  public static getName(name: string): { firstName: string; lastName: string } {
    const names = name.split(' ');
    if (names.length === 0) {
      return { firstName: '', lastName: '' };
    } else if (names.length === 1) {
      return { firstName: names[0], lastName: '' };
    } else {
      const lastName = names.pop() as string;
      return { firstName: names.join(' '), lastName };
    }
  }
  public static getAddress(address: Address) {
    const lines = [
      address.street,
      address.city,
      address.zipcode,
      address.state,
      address.country,
    ].filter((l) => !!l);
    return lines.join(', ');
  }

  public static passwordGenerator(length = 12) {
    const string = 'abcdefghijklmnopqrstuvwxyz'; //to upper
    const numeric = '0123456789';
    const punctuation = '!@#$%^&*()_+~`|}{[]:;?><,./-=';
    let password = '';
    let character = '';
    while (password.length < length) {
      const entity1 = Math.ceil(string.length * Math.random() * Math.random());
      const entity2 = Math.ceil(numeric.length * Math.random() * Math.random());
      const entity3 = Math.ceil(
        punctuation.length * Math.random() * Math.random()
      );
      let hold = string.charAt(entity1);
      hold = password.length % 2 == 0 ? hold.toUpperCase() : hold;
      character += hold;
      character += numeric.charAt(entity2);
      character += punctuation.charAt(entity3);
      password = character;
    }
    password = password
      .split('')
      .sort(function () {
        return 0.5 - Math.random();
      })
      .join('');
    return password.substring(0, length);
  }

  static stringGenrator(length: number, characters?: string) {
    let result = '';
    characters =
      characters ||
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  static slug(value: string): string {
    return kebabCase(value);
  }
  static toTitleCase(value?: string | string[]): string {
    if (!value) return '';
    const v = typeof value === 'string' ? value : value.join(', ');
    return v
      .replace(/_/g, ' ')
      .split(' ')
      .map(
        (v) =>
          `${(v[0] || '').toLocaleUpperCase()}${(
            v.substring(1) || ''
          ).toLocaleLowerCase()}`
      )
      .join(' ');
  }
  static getFileNameFromUrl(url: string) {
    const i = url.lastIndexOf('_') + 1;
    return url.substring(i);
  }
  static isExternalUrl(url?: string | string[]) {
    if (typeof url !== 'string') return false;
    return StringUtil.externalUrlRegx.test(url);
  }
}
